import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import {
  useGqlMutation,
  useSuspenseGqlQuery,
} from "@/lib/GraphQLCodegen/fetcher";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { toast } from "sonner";
import { quoteRecordQuery } from "@/app/Quotes/GraphQL/quoteRecordQuery";
import { sendQuoteMutation } from "@/app/Quotes/GraphQL/quoteMutations";

export function SendQuoteDialog({ quoteId }: { quoteId: string }) {
  const { data } = useSuspenseGqlQuery(quoteRecordQuery, {
    id: quoteId,
  });
  const { mutateAsync } = useGqlMutation(sendQuoteMutation);
  const { close } = useDialogState();

  const quote = data.quote;
  const defaultEmail = quote?.payee.billing_email ?? "";

  return (
    <BaseDialog
      title="Send Quote"
      subtitle={`Send quote ${quote?.reference} to the payee`}
    >
      <GenericForm<{ email: string }>
        initialValues={{
          email: defaultEmail,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: quoteId,
            email: values.email || undefined,
          });

          toast.success("Quote sent", {
            description: `Quote has been sent to ${values.email || defaultEmail}`,
          });

          close();
        }}
      >
        <TextInput
          name="email"
          label="Email"
          type="email"
          className="col-span-full"
        />

        <DialogSubmitButton text="Send Quote" />
      </GenericForm>
    </BaseDialog>
  );
}
